import type { FaireProductEntity } from "../../entity_types/product";

export const p_5h6zf65urh: FaireProductEntity = {
  token: "p_5h6zf65urh",
  type: "product",
  name: "ROUND NECK SHORT SLEEVE WOVEN KNIT MIX MIDI DRESS",
  brandToken: "b_pcc8wbctty",
  brandName: "Sunday Edition by LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/8d3fe63bdc866ff2be0c94ead34b60887dd542914fd4e6be369a9680b2a05796.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3394d210bfe624d7ca59a058b49e59fe80fba6081640e08b4e8efd2a6e76902a.jpeg",
    "https://cdn.faire.com/fastly/22175828605107aab317a281526506407bb119bb48428b0794c9ca84a95228eb.jpeg",
    "https://cdn.faire.com/fastly/13d090e5bad758a97ea741b3ce848cd5edc6b7c932aa2f40bc7171147fda30d0.jpeg",
    "https://cdn.faire.com/fastly/55ae33aec0470c42cf600347a3566ec39e999e40924e4af539abd9447ae51b38.jpeg",
    "https://cdn.faire.com/fastly/ed18658e97286b32c8337b9e982892b645e7268e2ab998b40c2d00913606c2aa.jpeg",
    "https://cdn.faire.com/fastly/4f6cdb96dac3b45d8d725e856a58318a7dca3b5e562e591d239dd8cfd4df5f18.jpeg",
    "https://cdn.faire.com/fastly/4487189bfec940b9eab94a5b850720b42913e278a14a6d4eb471fa2033f24efe.jpeg",
    "https://cdn.faire.com/fastly/7f136dd3035306b2d1b420518b08e7615db793aa2c0eb0b40d4d69008f627869.jpeg",
    "https://cdn.faire.com/fastly/02d18c99b15a1e509eced4d9653affbdda04b25ad46d95b064a2471813fd69c0.jpeg",
    "https://cdn.faire.com/fastly/bb100922207ab04402a405a7fd5e54e7032b681f9ba51756db76d5ebb0f71bdb.jpeg",
    "https://cdn.faire.com/fastly/c4476919b762dbae8c677d1660805b62d0044c83f563dae8fa2930259067b93a.jpeg",
    "https://cdn.faire.com/fastly/cd7ec5a5b03af71e657c362313fb11866d26d842286fc2b96ea3db46b753cf04.jpeg",
  ],
  priceDollars: 22,
  description:
    'MODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'10"\nBUST: 32\nWAIST: 25"\nHIPS: 35"',
  tags: [],
  msrpDollars: 62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:55.454Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
